import { render } from "./SitzungsartDetails.pug?vue&type=template&id=6be57bdc&lang=pug"
import script from "./SitzungsartDetails.js?vue&type=script&lang=js"
export * from "./SitzungsartDetails.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__